<template>
  <v-sheet class="d-flex flex-column align-center sizeLimiter">
    <h1>On Telemonial, you can:</h1>
    <h2>Connect with your friends and view their media ratings:</h2>
    <img :src="homeScreen" alt="Main Feed" />
    <h2>Create your own profile and customize your favorite works:</h2>
    <img :src="accountPage" alt="Profile Page" />
    <h2>Give your rating for podcasts, movies, books, and albums:</h2>
    <img :src="ratingPage" alt="Rating a Movie" />
    <h2>View statistics and reviews of individual works:</h2>
    <img :src="workPage" alt="Work Page" />
    <v-btn rounded class="primary white--text align-center mt-12 mb-4" :to="{ name: 'create-account' }">
      Create Your Account
    </v-btn>
  </v-sheet>
</template>

<script>
export default {
  name: "IntroPage",
  data: function () {
    return {
      homeScreen: require("../../images/homePage.png"),
      ratingPage: require("../../images/rate.png"),
      accountPage: require("../../images/profile.png"),
      workPage: require("../../images/work.png"),
    };
  },
};
</script>

<style scoped>
.sizeLimiter {
  max-width: 1024px;
}
h1,
h2 {
  text-align: center;
}
h1 {
  margin-top: 15px;
  font-size: 50px;
}
h2 {
  margin-top: 30px;
  margin-bottom: 8px;
  font-size: 24px;
}
img {
  max-width: 500px;
  width: 95%;
}
</style>
